import { render } from "./account.vue?vue&type=template&id=2ff33872&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=2ff33872&scoped=true&lang=css"

import exportComponent from "/Users/mathieu/conductor/workspaces/miakapp-v3/lima-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff33872"]])

export default __exports__